import { jwtDecode } from 'jwt-decode';

import { instanceOfJwtCliengoPayload, JwtCliengoPayload } from './types';

export function parseJwtCliengo(token: string): JwtCliengoPayload | undefined {
  if (!token) {
    return undefined;
  }

  const payload = jwtDecode<unknown>(token);

  if (instanceOfJwtCliengoPayload(payload)) {
    return payload;
  }

  return undefined;
}
